//------------------
// set spell values
//------------------
export default function setSpellValues() {
  console.log('----------------------------')
  console.log('IN setSpellValues')
  // -----------------
  // define structure
  // -----------------
  let spell = {
    //
    type: '',
    name: '',
    item_name: '',
    source_name: '',
    casting_rune_name: '',
    //
    mag: 1,
    // 
    spell: null, // static spell id
    character_item: null, // for item-linked spells
    character_rune: null, // for rune-linked spells
  }
  return spell
}
